
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Route, Switch } from 'react-router';
import { withRouter } from 'react-router-dom';

import SavedVehicles from 'containers/saved-vehicles';
import NewSavedVehicle from 'containers/saved-vehicles/new-vehicle';
import EditVehicle from 'containers/saved-vehicles/edit-vehicle';

import selectVehicleCreator from 'action-creators/vehicles/select-vehicle';
import initializeNewVehicleCreator from 'action-creators/vehicles/initialize-new-vehicle';

const propTypes = {
  selectVehicle: PropTypes.func.isRequired,
  initializeNewVehicle: PropTypes.func.isRequired,
};

const VehiclesRouterWrapper = ({ selectVehicle, initializeNewVehicle }) => (
  <div className="payment-methods">
    <Switch>
      <Route
        path="/account/vehicles/edit_vehicle/:vehicleId/"
        render={({ match }) => {
          selectVehicle(match.params);
          return <EditVehicle />;
        }}
      />
      <Route
        path="/account/vehicles/add/"
        render={() => {
          initializeNewVehicle();
          return <NewSavedVehicle />;
        }}
      />
      <Route
        path="/account/vehicles"
        render={() => <SavedVehicles />}
      />
    </Switch>
  </div>
);

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    selectVehicle: selectVehicleCreator,
    initializeNewVehicle: initializeNewVehicleCreator,
  }, dispatch)
);

const mapStateToProps = () => ({});

VehiclesRouterWrapper.propTypes = propTypes;
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(VehiclesRouterWrapper));
